<template>
  <el-select
    class="w-100"
    v-model="value"
    :loading="loading"
    :placeholder="$t('common.select')"
    filterable
    size="small"
    clearable
    remote
    @change="$emit('input', value)"
  >
    <el-option v-for="(item, index) in data" :key="index" :value="item.id" :label="item.name"/>
  </el-select>
</template>

<script>

export default {
  props: {
    selected: ''
  },

  data () {
    return {
      value: '',
      loading: false
    }
  },
  computed: {
    data () {
      return this.$store.getters['Organization/getOrganization']
    }
  },
  async mounted () {
    if (this.data.length === 0) {
      await this.$store.dispatch('Organization/getData', {page: 1, per_page: 'all'}).then((res) => {})
    }
  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/views/checklist/reports/OrgSelect.vue